import { useAnaliseLaboratorial } from "@/contexts/laboratorio/analiseLaboratorial/hooks/useAnaliseLaboratorial";
import { formatMessageError } from "@/shared/utils/formatMessageError";
import { App, Form, Input, Modal } from "antd";
import { useState } from "react";

interface FormValues {
  motivoCancelamento: string;
}

export function ModalCancelarAnaliseLaboratorial({
  isOpen,
  onClose,
  requisicaoId,
  reloadItems,
}: {
  isOpen: boolean;
  onClose: () => void;
  requisicaoId: number;
  reloadItems: () => void;
}) {
  const [form] = Form.useForm<FormValues>();
  const { message, notification } = App.useApp();
  const { cancelarAnaliseLaboratorialApi, listaRequisicoes, removeRequisicao } =
    useAnaliseLaboratorial();
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async ({ motivoCancelamento }: FormValues) => {
    try {
      setIsLoading(true);
      message.loading({
        content: "Cancelando Análise...",
        key: "loading",
        duration: 0,
      });
      await cancelarAnaliseLaboratorialApi(requisicaoId, motivoCancelamento);

      message.destroy("loading");
      setIsLoading(false);

      const requisicaoOffline = listaRequisicoes.find(
        (r) => r.id === requisicaoId
      );

      if (requisicaoOffline) {
        removeRequisicao(requisicaoOffline.offlineId!);
      }

      notification.success({
        message: "Análise cancelada com sucesso!",
      });

      reloadItems();

      form.resetFields();
      onClose();
    } catch (error) {
      console.error("Erro ao cancelar a análise:", error);
      message.destroy("loading");
      setIsLoading(false);
      const messageError = formatMessageError(error);
      notification.error({
        message: "Não foi possível cancelar a análise",
        description: messageError,
      });
      return;
    }
  };

  return (
    <Modal
      title="Cancelar Análise Laboratorial"
      open={isOpen}
      onCancel={() => {
        form.resetFields();
        onClose();
      }}
      okButtonProps={{
        form: "form-cancelar-analise",
        htmlType: "submit",
        danger: true,
        ghost: true,
        loading: isLoading,
        disabled: isLoading,
      }}
      cancelButtonProps={{
        disabled: isLoading,
      }}
      okText="Confirmar"
      cancelText="Fechar"
    >
      <Form
        layout="vertical"
        form={form}
        onFinish={handleSubmit}
        id="form-cancelar-analise"
      >
        <Form.Item
          label="Descreva o motivo para o cancelamento da análise"
          name="motivoCancelamento"
          rules={[{ required: true }]}
        >
          <Input.TextArea
            rows={4}
            placeholder="Informe o motivo do cancelamento"
          />
        </Form.Item>
      </Form>
    </Modal>
  );
}
